'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.dashboard').config(translationsConfig);

    function translationsConfig($translateProvider) {
        'ngInject';

        $translateProvider.translations('el', {
            'app': {
                'Homepage': 'Αρχική',
                'homepage-url': 'https://smartcity.heraklion.gr/el/home/'
            },
            'dashboard': {
                'Dashboard': 'Επισκόπηση ανοικτών δεδομένων'
            }
        });
    }
})();